import React from "react";
import { motion } from "framer-motion";

import styles from "./SingleItem.module.css";

import GifAnimation from "../../../atoms/GifAnimation";
import FullPlayer from "../../../atoms/FullPlayer";

import { titleAnimation, textAnimation } from "../../../../constants";

const Roles = ({ data }) => {
  const cleanedList = encodeURI(data)
    .split("%0D%0A")
    .map(v => decodeURI(v));

  return cleanedList.map(v => (
    <p key={v} className={styles.singleRole}>
      {v}
    </p>
  ));
};

const SingleItem = ({ data, lang = "en" }) => {
  const result = data || {};
  const output = key => result[key + "_" + lang];

  console.log("SingleItem:", result);

  // dangerouslySetInnerHTML
  // <p className={styles.description}>{output("description")}MMMM</p>

  return (
    <motion.div className={styles.itemModalContainer}>
      <h1 className={styles.title}>
        <GifAnimation gifSrc={titleAnimation()} noHover>
          {output("title")}
        </GifAnimation>
      </h1>

      <div className={styles.detailContainer}>
        <div className={styles.left}>
          <h3 className={styles.categories}>
            <GifAnimation gifSrc={textAnimation()} noHover>
              {result.category}
            </GifAnimation>
          </h3>

          <h3 className={styles.roles}>
            <GifAnimation gifSrc={textAnimation()} noHover>
              <Roles data={output("roles")} />
            </GifAnimation>
          </h3>

          <h3 className={styles.clients}>
            <GifAnimation gifSrc={textAnimation()} noHover>
              {output("clients")}, {result.date}
            </GifAnimation>
          </h3>
        </div>

        <div className={styles.right}>
          {output("description") && (
            <div dangerouslySetInnerHTML={{__html:output("description")}} />
          )}
        </div>
      </div>

      <FullPlayer result={result} />
    </motion.div>
  );
};

export default SingleItem;
